import React from 'react';
import Button from '../../inputs/Button';
const renderControls = (handleClose, actions) => {
    const [primaryAction, secondaryAction] = actions || [];
    return (React.createElement(React.Fragment, null,
        primaryAction && (React.createElement(Button, { variant: "inverted", width: "large", onClick: primaryAction.action || handleClose }, primaryAction.label)),
        secondaryAction && (React.createElement(Button, { variant: "secondary", width: "large", onClick: secondaryAction.action || handleClose }, secondaryAction.label))));
};
export default renderControls;
//# sourceMappingURL=renderControls.js.map